/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { InlineSelect } from "./InlineSelect";
import { InlineText } from "./InlineText";
import { InlineEditProps } from "./types";

export function InlineEdit({ selectOptions, ...inputProps }: InlineEditProps) {
  if (selectOptions !== undefined) {
    return <InlineSelect {...inputProps} selectOptions={selectOptions} />;
  }
  return <InlineText {...inputProps} />;
}
